import AppNew from "../src/stores/routerStore";
import React from "react";

const App = () => <AppNew />;

export default App;
